"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Alert = require("./Alert.style");

var _SuccessIcon = _interopRequireDefault(require("../images/SuccessIcon"));

var _ErrorIcon = _interopRequireDefault(require("../images/ErrorIcon"));

var _CloseIcon = _interopRequireDefault(require("../images/CloseIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function Alert(_ref) {
  var success = _ref.success,
      open = _ref.open,
      warning = _ref.warning,
      handleClose = _ref.handleClose,
      error = _ref.error,
      message = _ref.message,
      duration = _ref.duration,
      action = _ref.action,
      position = _ref.position,
      info = _ref.info,
      rest = _objectWithoutProperties(_ref, ["success", "open", "warning", "handleClose", "error", "message", "duration", "action", "position", "info"]);

  (0, _react.useEffect)(function () {
    var timer;

    if (open) {
      timer = setTimeout(function () {
        return handleClose();
      }, duration);
    }

    return function () {
      clearTimeout(timer);
    };
  }, [open]);
  return /*#__PURE__*/_react["default"].createElement(_Alert.Wrapper, _extends({
    open: open,
    position: position
  }, rest), /*#__PURE__*/_react["default"].createElement(_Alert.Container, null, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      display: "flex",
      alignItems: "center"
    }
  }, /*#__PURE__*/_react["default"].createElement(_Alert.IconContainer, {
    "data-testid": "alert",
    success: success,
    warning: warning,
    error: error,
    info: info
  }, success ? /*#__PURE__*/_react["default"].createElement(_SuccessIcon["default"], null) : /*#__PURE__*/_react["default"].createElement(_ErrorIcon["default"], null)), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      paddingLeft: "8px",
      paddingRight: "8px"
    }
  }, message)), !action && /*#__PURE__*/_react["default"].createElement(_CloseIcon["default"], {
    "data-testid": "closeIcon",
    style: {
      cursor: "pointer"
    },
    onClick: handleClose
  }), action));
}

Alert.defaultProps = {
  open: false,
  position: "topRight",
  duration: 5000
};
Alert.propTypes = {
  open: _propTypes["default"].bool.isRequired,
  position: _propTypes["default"].oneOf(["topLeft", "topRight", "bottomLeft", "bottomRight"]),
  success: _propTypes["default"].bool,
  error: _propTypes["default"].bool,
  warning: _propTypes["default"].bool,
  info: _propTypes["default"].bool,
  message: _propTypes["default"].string.isRequired,
  action: _propTypes["default"].element,
  duration: _propTypes["default"].number,
  handleClose: _propTypes["default"].func.isRequired
};
var _default = Alert;
exports["default"] = _default;